import ContactMap from './ContactMap';

export default ContactMap;
